export const HtmlDecode = (string) => {
  var e = document.createElement("textarea");
  e.innerHTML = string;
  // handle case of empty input
  return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
};
